import { PaddingClassesType } from "../types";

export const borderClasses = "cui-border-0 cui-border-solid cui-border-b-1 cui-border-fg-primary-minimal !cui-gap-r-0";
export const spanMap = {
  0: "full",
  1: 10,
  2: 8,
  3: 6,
  4: 4
};
export const spanMapInverse = {
  1: 2,
  2: 4,
  3: 6,
  4: 8
};

export const DEFAULT_PADDING = "cui-pb-1";

export const getPaddingClasses = (paddingClasses?: PaddingClassesType): string => {
  if (typeof paddingClasses === "string") return paddingClasses;
  if (typeof paddingClasses === "object") {
    const { top, left, right, bottom } = paddingClasses;
    return `${DEFAULT_PADDING} ${[top, left, right, bottom].filter(Boolean).join(" ")}`;
  }
  return DEFAULT_PADDING;
};
